export const AUTH_ERROR_CODES = [401, 403];

export const GET_PROVIDERS_SUCCESS = 'GET_PROVIDERS_SUCCESS';
export const GET_PROVIDERS_ERROR = 'GET_PROVIDERS_ERROR';
export const GET_PROVIDER_SUCCESS = 'GET_PROVIDER_SUCCESS';
export const GET_PROVIDER_ERROR = 'GET_PROVIDER_ERROR';

export const POST_PROVIDER_SUCCESS = 'POST_PROVIDER_SUCCESS';
export const POST_PROVIDER_ERROR = 'POST_PROVIDER_ERROR';

export const POST_CLONE_PROVIDER_SUCCESS = 'POST_CLONE_PROVIDER_SUCCESS';
export const POST_CLONE_PROVIDER_ERROR = 'POST_CLONE_PROVIDER_ERROR';

export const PATCH_PROVIDER_SUCCESS = 'PATCH_PROVIDER_SUCCESS';
export const PATCH_PROVIDER_ERROR = 'PATCH_PROVIDER_ERROR';

export const PUT_POIS_SUCCESS = 'PUT_POIS_SUCCESS';
export const PUT_POIS_ERROR = 'PUT_POIS_ERROR';
export const UPLOAD_POI_MEDIA_SUCCESS = 'UPLOAD_POI_MEDIA_SUCCESS';
export const UPLOAD_POI_MEDIA_ERROR = 'UPLOAD_POI_MEDIA_ERROR';

export const GET_ITEMS_SUCCESS = 'GET_ITEMS_SUCCESS';
export const GET_NOT_ACTIVE_ITEMS_SUCCESS = 'GET_NOT_ACTIVE_ITEMS_SUCCESS';
export const GET_ITEMS_ERROR = 'GET_ITEMS_ERROR';
export const GET_ITEMS_BY_PROVIDER_ID_SUCCESS = 'GET_ITEMS_BY_PROVIDER_ID_SUCCESS';
export const GET_ITEMS_BY_PROVIDER_ID_ERROR = 'GET_ITEMS_BY_PROVIDER_ID_ERROR';
export const GET_ITEM_SUCCESS = 'GET_ITEM_SUCCESS';
export const GET_ITEM_ERROR = 'GET_ITEM_ERROR';
export const GET_ITEM_BY_ID_SUCCESS = 'GET_ITEM_BY_ID_SUCCESS';
export const GET_ITEM_BY_ID_ERROR = 'GET_ITEM_BY_ID_ERROR';

export const POST_ITEM_SUCCESS = 'POST_ITEM_SUCCESS';
export const POST_ITEM_ERROR = 'POST_ITEM_ERROR';

export const PATCH_ITEM_SUCCESS = 'PATCH_ITEM_SUCCESS';
export const PATCH_ITEM_ERROR = 'PATCH_ITEM_ERROR';

export const BULK_DELETE_ITEMS_SUCCESS = 'BULK_DELETE_ITEMS_SUCCESS';
export const BULK_DELETE_ITEMS_ERROR = 'BULK_DELETE_ITEMS_ERROR';
export const BULK_DELETE_ITEMS_INPROGRESS = 'BULK_DELETE_ITEMS_INPROGRESS';

export const ITEMS_SCROLL_POS = 'ITEMS_SCROLL_POS';


export const GET_CLUES_SUCCESS = 'GET_CLUES_SUCCESS';
export const GET_CLUES_ERROR = 'GET_CLUES_ERROR';
export const GET_CLUES_BY_PROVIDER_ID_ERROR = 'GET_CLUES_BY_PROVIDER_ID_ERROR';
export const GET_CLUES_BY_PROVIDER_ID_SUCCESS = 'GET_CLUES_BY_PROVIDER_ID_SUCCESS';
export const GET_CLUES_BY_SPARK_ID_ERROR = 'GET_CLUES_BY_SPARK_ID_ERROR';
export const GET_CLUES_BY_SPARK_ID_SUCCESS = 'GET_CLUES_BY_SPARK_ID_SUCCESS';

export const POST_CLUE_SUCCESS = 'POST_CLUE_SUCCESS';
export const POST_CLUE_ERROR = 'POST_CLUE_ERROR';

export const PATCH_CLUE_SUCCESS = 'PATCH_CLUE_SUCCESS';
export const PATCH_CLUE_ERROR = 'PATCH_CLUE_ERROR';

export const UPLOAD_CLUE = 'UPLOAD_CLUE';
export const UPLOAD_CLUE_SUCCESS = 'UPLOAD_CLUE_SUCCESS';
export const UPLOAD_CLUE_ERROR = 'UPLOAD_CLUE_ERROR';

export const GET_ROUTES_SUCCESS = 'GET_ROUTES_SUCCESS';
export const GET_ROUTES_ERROR = 'GET_ROUTES_ERROR';
export const GET_ROUTE_SUCCESS = 'GET_ROUTE_SUCCESS';
export const GET_ROUTE_ERROR = 'GET_ROUTE_ERROR';
export const GET_ROUTE_AGGREGATE_BY_ID_SUCCESS = 'GET_ROUTE_AGGREGATE_BY_ID_SUCCESS';
export const GET_ROUTE_AGGREGATE_BY_ID_ERROR = 'GET_ROUTE_AGGREGATE_BY_ID_ERROR';
export const GET_ROUTES_BY_PRODUCT_ID_SUCCESS = 'GET_ROUTES_BY_PRODUCT_ID_SUCCESS';
export const GET_ROUTES_BY_PRODUCT_ID_ERROR = 'GET_ROUTES_BY_PRODUCT_ID_ERROR';

export const PATCH_ROUTE_ERROR = 'PATCH_ROUTE_ERROR';
export const PATCH_ROUTE_SUCCESS = 'PATCH_ROUTE_SUCCESS';

export const PATCH_STOP_ERROR = 'PATCH_STOP_ERROR';
export const PATCH_STOP_SUCCESS = 'PATCH_STOP_SUCCESS';

export const PUT_STOP_ERROR = 'PUT_STOP_ERROR';
export const PUT_STOP_SUCCESS = 'PUT_STOP_SUCCESS';

export const POST_ROUTE_SUCCESS = 'POST_ROUTE_SUCCESS';
export const POST_ROUTE_ERROR = 'POST_ROUTE_ERROR';

export const CREATE_ROUTES_ERROR = 'CREATE_ROUTES_ERROR';
export const CREATE_ROUTES_SUCCESS = 'CREATE_ROUTES_SUCCESS';

export const UPLOAD_ROUTE_INTRODUCTION = 'UPLOAD_ROUTE_INTRODUCTION';
export const UPLOAD_ROUTE_INTRODUCTION_SUCCESS = 'UPLOAD_ROUTE_INTRODUCTION_SUCCESS';
export const UPLOAD_ROUTE_INTRODUCTION_ERROR = 'UPLOAD_ROUTE_INTRODUCTION_ERROR';

export const GET_PRODUCTS_SUCCESS = 'GET_PRODUCTS_SUCCESS';
export const GET_PRODUCTS_ERROR = 'GET_PRODUCTS_ERROR';
export const GET_PRODUCT_BY_ID_SUCCESS = 'GET_PRODUCT_BY_ID_SUCCESS';
export const GET_PRODUCT_BY_ID_ERROR = 'GET_PRODUCT_BY_ID_ERROR';

export const GET_BOOKING_ATTEMPT = 'GET_BOOKING_ATTEMPT';
export const GET_BOOKINGS_SUCCESS = 'GET_BOOKINGS_SUCCESS';
export const GET_BOOKINGS_ERROR = 'GET_BOOKINGS_ERROR';
export const GET_BOOKING_NOTIFICATION_DATA_SUCCESS = 'GET_BOOKING_NOTIFICATION_DATA_SUCCESS';
export const GET_BOOKING_NOTIFICATION_DATA_ERROR = 'GET_BOOKING_NOTIFICATION_DATA_ERROR';
export const PATCH_BOOKING_ERROR = 'PATCH_BOOKING_ERROR';
export const PATCH_BOOKING_SUCCESS = 'PATCH_BOOKING_SUCCESS';
export const PUT_BOOKING_ITEM_PRICE_ERROR = 'PUT_BOOKING_ITEM_PRICE_ERROR';
export const PUT_BOOKING_ITEM_PRICE_SUCCESS = 'PUT_BOOKING_ITEM_PRICE_SUCCESS';
export const PUT_BOOKING_STOP_ERROR = 'PUT_BOOKING_STOP_ERROR';
export const PUT_BOOKING_STOP_SUCCESS = 'PUT_BOOKING_STOP_SUCCESS';
export const DELETE_ONE_BOOKING_STOP_PROVIDER_ERROR = 'DELETE_ONE_BOOKING_STOP_PROVIDER_ERROR';
export const DELETE_ONE_BOOKING_STOP_PROVIDER_SUCCESS = 'DELETE_ONE_BOOKING_STOP_PROVIDER_SUCCESS';
export const DELETE_ONE_BOOKING_STOP_SPARK_ERROR = 'DELETE_ONE_BOOKING_STOP_SPARK_ERROR';
export const DELETE_ONE_BOOKING_STOP_SPARK_SUCCESS = 'DELETE_ONE_BOOKING_STOP_SPARK_SUCCESS';
export const PUT_BOOKING_ITEM_ERROR = 'PUT_BOOKING_ITEM_ERROR';
export const PUT_BOOKING_ITEM_SUCCESS = 'PUT_BOOKING_ITEM_SUCCESS';
export const PUT_BOOKING_MANAGER_ERROR = 'PUT_BOOKING_MANAGER_ERROR';
export const PUT_BOOKING_MANAGER_SUCCESS = 'PUT_BOOKING_MANAGER_SUCCESS';
export const PUT_STOP_BOOKING_NOTES_ERROR = 'PUT_STOP_BOOKING_NOTES_ERROR';
export const PUT_STOP_BOOKING_NOTES_SUCCESS = 'PUT_STOP_BOOKING_NOTES_SUCCESS';
export const POST_BOOKING_ITEM_PAYMENT_ERROR = 'POST_BOOKING_ITEM_PAYMENT_ERROR';
export const POST_BOOKING_ITEM_PAYMENT_SUCCESS = 'POST_BOOKING_ITEM_PAYMENT_SUCCESS';
export const POST_BOOKING_ITEM_ACTIVITY_ERROR = 'POST_BOOKING_ITEM_ACTIVITY_ERROR';
export const POST_BOOKING_ITEM_ACTIVITY_SUCCESS = 'POST_BOOKING_ITEM_ACTIVITY_SUCCESS';

export const PATCH_BOOKING_STOPS_ORDER_ERROR = 'PATCH_BOOKING_STOPS_ORDER_ERROR';
export const PATCH_BOOKING_STOPS_ORDER_SUCCESS = 'PATCH_BOOKING_STOPS_ORDER_SUCCESS';

export const PUT_BOOKING_DELIVERY_STATUS_ERROR = 'PUT_BOOKING_DELIVERY_STATUS_ERROR';
export const PUT_BOOKING_DELIVERY_STATUS_SUCCESS = 'PUT_BOOKING_DELIVERY_STATUS_SUCCESS';

export const GET_OPTIONS_SUCCESS = 'GET_OPTIONS_SUCCESS';
export const GET_OPTIONS_ERROR = 'GET_OPTIONS_ERROR';

export const GET_OPTIONS_BY_FILTERS_SUCCESS = 'GET_OPTIONS_BY_FILTERS_SUCCESS';
export const GET_OPTIONS_BY_FILTERS_ERROR = 'GET_OPTIONS_BY_FILTERS_ERROR';

export const POST_PREVIEW_CONFIRMATION_SUCCESS = 'POST_PREVIEW_CONFIRMATION_SUCCESS';
export const POST_PREVIEW_CONFIRMATION_ERROR = 'POST_PREVIEW_CONFIRMATION_ERROR';
export const POST_SEND_CONFIRMATION_SUCCESS = 'POST_SEND_CONFIRMATION_SUCCESS';
export const POST_SEND_CONFIRMATION_ERROR = 'POST_SEND_CONFIRMATION_ERROR';
export const POST_SEND_CODE_SUCCESS = 'POST_SEND_CODE_SUCCESS';
export const POST_SEND_CODE_ERROR = 'POST_SEND_CODE_ERROR';
export const POST_BOOKING_NOTIFICATION_SUCCESS = 'POST_BOOKING_NOTIFICATION_SUCCESS';
export const POST_BOOKING_NOTIFICATION_ERROR = 'POST_BOOKING_NOTIFICATION_ERROR';
export const DELETE_ONE_BOOKING_ROUTE_SUCCESS = 'DELETE_ONE_BOOKING_ROUTE_SUCCESS';
export const DELETE_ONE_BOOKING_ROUTE_ERROR = 'DELETE_ONE_BOOKING_ROUTE_ERROR';
export const DELETE_ONE_BOOKING_VIRTUAL_SUCCESS = 'DELETE_ONE_BOOKING_VIRTUAL_SUCCESS';
export const DELETE_ONE_BOOKING_VIRTUAL_ERROR = 'DELETE_ONE_BOOKING_VIRTUAL_ERROR';

export const GET_USERS_SUCCESS = 'GET_USERS_SUCCESS';
export const GET_USERS_ERROR = 'GET_USERS_ERROR';
export const GET_USER_BY_ID_SUCCESS = 'GET_USER_BY_ID_SUCCESS';
export const GET_USER_BY_ID_ERROR = 'GET_USER_BY_ID_ERROR';

export const GET_AUTH_SUCCESS = 'GET_AUTH_SUCCESS';

export const GET_PLACES_SUCCESS = 'GET_PLACES_SUCCESS';
export const GET_PLACES_ERROR = 'GET_PLACES_ERROR';
export const GET_PLACE_SUCCESS = 'GET_PLACE_SUCCESS';
export const GET_PLACE_ERROR = 'GET_PLACE_ERROR';
export const POST_PLACE_SUCCESS = 'POST_PLACE_SUCCESS';
export const POST_PLACE_ERROR = 'POST_PLACE_ERROR';
export const PATCH_PLACE_SUCCESS = 'PATCH_PLACE_SUCCESS';
export const PATCH_PLACE_ERROR = 'PATCH_PLACE_ERROR';

export const GET_MORETOEXPLORECOLLECTION_SUCCESS = 'GET_MORETOEXPLORECOLLECTION_SUCCESS';
export const GET_MORETOEXPLORECOLLECTION_ERROR = 'GET_MORETOEXPLORECOLLECTION_ERROR';
export const GET_MORETOEXPLORE_SUCCESS = 'GET_MORETOEXPLORE_SUCCESS';
export const GET_MORETOEXPLORE_ERROR = 'GET_MORETOEXPLORE_ERROR';
export const POST_MORETOEXPLORE_SUCCESS = 'POST_MORETOEXPLORE_SUCCESS';
export const POST_MORETOEXPLORE_ERROR = 'POST_MORETOEXPLORE_ERROR';
export const PATCH_MORETOEXPLORE_SUCCESS = 'PATCH_MORETOEXPLORE_SUCCESS';
export const PATCH_MORETOEXPLORE_ERROR = 'PATCH_MORETOEXPLORE_ERROR';

export const CREATE_NEW_SPARK_SUCCESS = 'CREATE_NEW_SPARK_SUCCESS';
export const GET_SPARKS_SUCCESS = 'GET_SPARKS_SUCCESS';
export const GET_SPARKS_ERROR = 'GET_SPARKS_ERROR';
export const GET_SPARK_SUCCESS = 'GET_SPARK_SUCCESS';
export const GET_SPARK_ERROR = 'GET_SPARK_ERROR';
export const POST_SPARK_SUCCESS = 'POST_SPARK_SUCCESS';
export const POST_SPARK_ERROR = 'POST_SPARK_ERROR';
export const PATCH_SPARK_SUCCESS = 'PATCH_SPARK_SUCCESS';
export const PATCH_SPARK_ERROR = 'PATCH_SPARK_ERROR';
export const PUT_ADDITIONAL_FUNS_SUCCESS = 'PUT_ADDITIONAL_FUNS_SUCCESS';
export const PUT_ADDITIONAL_FUNS_ERROR = 'PUT_ADDITIONAL_FUNS_ERROR';

export const GET_CHALLENGES_SUCCESS = 'GET_CHALLENGES_SUCCESS';
export const GET_CHALLENGES_ERROR = 'GET_CHALLENGES_ERROR';
export const GET_CHALLENGES_BY_SPARK_ID_SUCCESS = 'GET_CHALLENGES_BY_SPARK_ID_SUCCESS';
export const GET_CHALLENGES_BY_SPARK_ID_ERROR = 'GET_CHALLENGES_BY_SPARK_ID_ERROR';
export const GET_CHALLENGE_SUCCESS = 'GET_CHALLENGE_SUCCESS';
export const GET_CHALLENGE_ERROR = 'GET_CHALLENGE_ERROR';
export const GET_CHALLENGE_BY_ID_SUCCESS = 'GET_CHALLENGE_BY_ID_SUCCESS';
export const GET_CHALLENGE_BY_ID_ERROR = 'GET_CHALLENGE_BY_ID_ERROR';

export const POST_CHALLENGE_SUCCESS = 'POST_CHALLENGE_SUCCESS';
export const POST_CHALLENGE_ERROR = 'POST_CHALLENGE_ERROR';

export const PATCH_CHALLENGE_SUCCESS = 'PATCH_CHALLENGE_SUCCESS';
export const PATCH_CHALLENGE_ERROR = 'PATCH_CHALLENGE_ERROR';

export const CREATE_NEW_VIRTUAL_SUCCESS = 'CREATE_NEW_VIRTUAL_SUCCESS';
export const GET_VIRTUALS_SUCCESS = 'GET_VIRTUALS_SUCCESS';
export const GET_VIRTUALS_ERROR = 'GET_VIRTUALS_ERROR';
export const GET_VIRTUAL_SUCCESS = 'GET_VIRTUAL_SUCCESS';
export const GET_VIRTUAL_ERROR = 'GET_VIRTUAL_ERROR';
export const POST_VIRTUAL_SUCCESS = 'POST_VIRTUAL_SUCCESS';
export const POST_VIRTUAL_ERROR = 'POST_VIRTUAL_ERROR';
export const PATCH_VIRTUAL_SUCCESS = 'PATCH_VIRTUAL_SUCCESS';
export const PATCH_VIRTUAL_ERROR = 'PATCH_VIRTUAL_ERROR';
export const GET_VIRTUALS_BY_PRODUCT_ID_SUCCESS = 'GET_VIRTUALS_BY_PRODUCT_ID_SUCCESS';
export const GET_VIRTUALS_BY_PRODUCT_ID_ERROR = 'GET_VIRTUALS_BY_PRODUCT_ID_ERROR';

export const UPLOAD_MEDIA_SUCCESS = 'UPLOAD_MEDIA_SUCCESS';
export const UPLOAD_MEDIA_ERROR = 'UPLOAD_MEDIA_ERROR';

export const GET_STORYBOARDS_BY_PROVIDER_ID_SUCCESS = 'GET_STORYBOARDS_BY_PROVIDER_ID_SUCCESS';
export const GET_STORYBOARDS_BY_PROVIDER_ID_ERROR = 'GET_STORYBOARDS_BY_PROVIDER_ID_ERROR';
export const GET_STORYBOARD_SUCCESS = 'GET_STORYBOARD_SUCCESS';
export const GET_STORYBOARD_ERROR = 'GET_STORYBOARD_ERROR';
export const GET_STORYBOARD_BY_ID_SUCCESS = 'GET_STORYBOARD_BY_ID_SUCCESS';
export const GET_STORYBOARD_BY_ID_ERROR = 'GET_STORYBOARD_BY_ID_ERROR';
export const POST_STORYBOARD_SUCCESS = 'POST_STORYBOARD_SUCCESS';
export const POST_STORYBOARD_ERROR = 'POST_STORYBOARD_ERROR';
export const PATCH_STORYBOARD_SUCCESS = 'PATCH_STORYBOARD_SUCCESS';
export const PATCH_STORYBOARD_ERROR = 'PATCH_STORYBOARD_ERROR';
export const DELETE_STORYBOARD_SUCCESS = 'DELETE_STORYBOARD_SUCCESS';
export const DELETE_STORYBOARD_ERROR = 'DELETE_STORYBOARD_ERROR';
export const CLEAR_ERROR = 'CLEAR_ERROR';
export const LINKED_USERS_ERROR='LINKED_USERS_ERROR';
export const LINKED_USERS_SUCCESS='LINKED_USERS_SUCCESS';
export const PATCH_BOOKINGS_ERROR = 'PATCH_BOOKINGS_ERROR';
export const PATCH_BOOKINGS_SUCCESS = 'PATCH_BOOKINGS_SUCCESS';
export const PATCH_BOOKINGS_REFRESH = 'PATCH_BOOKINGS_REFRESH';
export const DELETE_LINKED_USERS_ERROR='DELETE_LINKED_USERS_ERROR';
export const DELETE_LINKED_USERS_SUCCESS='DELETE_LINKED_USERS_SUCCESS';
export const PUT_BOOKING_IS_PERSONALISED_ERROR = 'PUT_BOOKING_IS_PERSONALISED_ERROR';
export const PUT_BOOKING_IS_PERSONALISED_SUCCESS = 'PUT_BOOKING_IS_PERSONALISED_SUCCESS';
export const CLEAR_ROUTE_ERROR = 'CLEAR_ROUTE_ERROR';
